var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2854 7.71498C17.13 8.55963 18.2974 8.88444 19.3902 8.68967L19.9917 9.29111L17.1514 12.1313L11.8687 6.84855L14.7089 4.00832L15.3107 4.61011C15.1159 5.70297 15.4407 6.87032 16.2854 7.71498ZM10.4485 8.26867L4.00832 14.7089L4.60976 15.3103C5.70263 15.1156 6.86998 15.4404 7.71463 16.285C8.55928 17.1297 8.8841 18.297 8.68933 19.3899L9.29111 19.9917L15.7313 13.5515L10.4485 8.26867ZM6.29451 17.7051C6.88288 18.2935 6.88275 19.2471 6.29451 19.8353L7.87099 21.4118C8.65525 22.196 9.92692 22.1961 10.7112 21.4118L21.4118 10.7112C22.1961 9.92692 22.196 8.65525 21.4118 7.87099L19.8357 6.29486C19.2474 6.88309 18.2938 6.88322 17.7055 6.29486C17.1171 5.7065 17.1173 4.75292 17.7055 4.16469L16.129 2.58821C15.3448 1.80396 14.0731 1.8039 13.2888 2.58821L2.58821 13.2888C1.8039 14.0731 1.80396 15.3448 2.58821 16.129L4.16434 17.7051C4.75258 17.1169 5.70615 17.1168 6.29451 17.7051Z",
    fill: "#A5ACBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.976e3349be1f82b0daa3e9b419bbf512.svg";
export { ForwardRef as ReactComponent };